import { PLACEMENT } from './constants';
import { Placement } from './types';
import styles from '../blocks/Overlay/Overlay.scss';

const ANIMATION_CLASS_NAMES = {
  enter: {
    [PLACEMENT.TOP]: styles.contentIsHiddenTop,
    [PLACEMENT.BOTTOM]: styles.contentIsHiddenBottom,
  },
  enterActive: {
    [PLACEMENT.TOP]: styles.contentIsShowingTop,
    [PLACEMENT.BOTTOM]: styles.contentIsShowingBottom,
  },
  enterDone: {
    [PLACEMENT.TOP]: styles.contentIsShowedTop,
    [PLACEMENT.BOTTOM]: styles.contentIsShowedBottom,
  },
  exit: {
    [PLACEMENT.TOP]: styles.contentIsShowedTop,
    [PLACEMENT.BOTTOM]: styles.contentIsShowedBottom,
  },
  exitActive: {
    [PLACEMENT.TOP]: styles.contentIsHidingTop,
    [PLACEMENT.BOTTOM]: styles.contentIsHidingBottom,
  },
  exitDone: {
    [PLACEMENT.TOP]: styles.contentIsHiddenTop,
    [PLACEMENT.BOTTOM]: styles.contentIsHiddenBottom,
  },
};

export const getAnimationClassNames = (placement: Placement) => {
  return {
    enter: ANIMATION_CLASS_NAMES.enter[placement],
    enterActive: ANIMATION_CLASS_NAMES.enterActive[placement],
    enterDone: ANIMATION_CLASS_NAMES.enterDone[placement],
    exit: ANIMATION_CLASS_NAMES.exit[placement],
    exitActive: ANIMATION_CLASS_NAMES.exitActive[placement],
    exitDone: ANIMATION_CLASS_NAMES.exitDone[placement],
  };
};
